import React from 'react';

/**
 * Use this to manage the scaling of your content.
 * This will set transform to scale(props.scale), and downscale your height and width by props.scale, so that
 * the inner component will always receive the same height and width regardless of scale.
 */
export function ScaleWithPageContainer(props: {
  height: number;
  width: number;
  scale: number;
  scaleWithPage: boolean;
  children:
    | ((params: { width: number; height: number }) => React.ReactNode)
    | React.ReactNode;
}) {
  const height = !props.scaleWithPage
    ? props.height
    : props.height / props.scale;

  const width = !props.scaleWithPage ? props.width : props.width / props.scale;

  return (
    <div
      style={{
        transformOrigin: props.scaleWithPage ? 'top left' : undefined,
        transform: props.scaleWithPage
          ? `scale(${props.scale}) translate3d(0,0,0)`
          : undefined,

        width: width,
        height: height,
      }}
    >
      {typeof props.children === 'function'
        ? props.children({ width, height })
        : props.children}
    </div>
  );
}
